import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
// import { HttpModule } from '@angular/http';
import { APP_BASE_HREF } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule } from "@angular/common/http";

import { AppComponent } from "./app.component";

import { SidebarModule } from "./sidebar/sidebar.module";
import { FixedPluginModule } from "./shared/fixedplugin/fixedplugin.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { AppRoutes } from "./app.routing";
import { MainComponent } from "./final/main/main.component";
import { RegComponent } from "./final/reg/reg.component";
import { LogComponent } from "./final/log/log.component";
import { ManagerComponent } from "./final/manager/manager.component";
import { ParticipantComponent } from "./final/participant/participant.component";
import { TestComponent } from "./final/test/test.component";
import { SpinnerComponent } from "./final/spinner/spinner.component";
import { EventComponent } from "./final/event/event.component";

import { DataService } from "./services/data.service";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
    }),
    NgbModule,
    // HttpModule,
    SidebarModule,
    ReactiveFormsModule,
    NavbarModule,
    FooterModule,
    FixedPluginModule,
  ],
  providers: [DataService],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    MainComponent,
    RegComponent,
    LogComponent,
    ManagerComponent,
    ParticipantComponent,
    TestComponent,
    SpinnerComponent,
    EventComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
